import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	expand: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	collapse: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	resizeButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	resizeBoundaryLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	expand: {
		id: 'software-releases-version-detail.right-sidebar.resize-control.expand',
		defaultMessage: 'Expand',
		description: 'The expand sidebar tooltip text',
	},
	collapse: {
		id: 'software-releases-version-detail.right-sidebar.resize-control.collapse',
		defaultMessage: 'Collapse',
		description: 'The collapse sidebar tooltip text',
	},
	resizeButtonLabel: {
		id: 'software-releases-version-detail.right-sidebar.resize-control.resize-button-label',
		defaultMessage:
			'Button which can be clicked to expand and collapse the version details right sidebar',
		description:
			'Label for the resize button used to expand and collapse the version details right sidebar',
	},
	resizeBoundaryLabel: {
		id: 'software-releases-version-detail.right-sidebar.resize-control.resize-boundary-label',
		defaultMessage:
			'Boundary line which can be clicked to expand and collapse the version details right sidebar',
		description:
			'Label for the resize boundary used to expand and collapse the version details right sidebar',
	},
});
